define('viewmodels/app/__allCharts',['lodash', 'jquery', 'knockout', 'atn/atn', 'chartApi/index', 'dataSource/timeData', 'dataSource/userPreferences', 'plugins/router'],
        function (_, $, ko, atn, chartApi, timeData, userPreferences, rootRouter) {
            'use strict';


            var dashboardChartList = ko.observableArray();
            var dashboardList = ko.observableArray();
            var allChartConfig;
            var activeDashboard = ko.observable();
            var activeDashboardName =  ko.observable();
            
            function loadDashboards() {
                var deferred = $.Deferred();
                $.ajax({
                    url: atn.config.api.dashboards + '?' + (new Date()).getTime(),
                    type: 'GET',
                    dataType: 'json',
                    success: function (list) {
                        dashboardList(list);
                        var preferencesPromise = userPreferences.getUserPreferences();
                        preferencesPromise.done(function(){
                            var first = true;
                            var dashboardId;
                            _.each(list, function(dashboard){
                                if(first){
                                    dashboardId = dashboard.id;
                                    first = false;
                                }
                                if(userPreferences.allUserPreferences().ACTIVE_DASHBOARD === dashboard.id){
                                    dashboardId = dashboard.id;
                                }
                            });
                            activeDashboard(null); 
                            // to trigger change event when this function is called but same dashboard is selected
                            // this case happens when user refreshes on reports screen and then navigates to dashboard
                            activeDashboard(dashboardId);
                            deferred.resolve();
                        });
                        
                        preferencesPromise.fail(function(){
                            deferred.reject();
                        });
                    },
                    error: function () {
                        deferred.reject();
                    }
                });

                return deferred.promise();
            }

            function loadCharts() {
                /**
                 * List of Ids of chart in this Dashboard, should be in initial sort order
                 * @type {string[]}
                 */
                var sortedChartList = [];
                
                _.each(dashboardList(), function(dashboard){
                    if(activeDashboard() === dashboard.id){
                        activeDashboardName(dashboard.title);
                        sortedChartList = dashboard.charts;
                    }
                });

                /**
                 * order list of chart list. Should always be kept in order. Need for creating pdf
                 *
                 * @type {Array}
                 */
                $.allSettled([timeData.getLatestDbTimeBoundary(), userPreferences.getUserPreferences()]).
                        done(function () {
                            dashboardChartList(_.map(sortedChartList, function (chartId) {
                                return chartApi.createChartComponent(chartId, userPreferences.userPreferences());
                            }));
                        }).
                        fail(function () {
                            _.defer(rootRouter.navigate, '#site/failure/dataFetch');
                        });

                /**
                 * list of all available charts
                 * @type {Object[]}
                 */
                allChartConfig = _.map(chartApi.matrixCharts.charts, function (value) {
                    return value;
                });
            }

            return {
                dashboardChartList: dashboardChartList,
                dashboardList: dashboardList,
                allChartConfig: allChartConfig,
                activeDashboard: activeDashboard,
                activeDashboardName: activeDashboardName,
                loadDashboards: loadDashboards,
                loadCharts: loadCharts
            };
        });

